import {
  SendOut,
  ExternalInstitutionReason,
} from "../services/sendOuts.service";
import { stripHtml } from "./helpers";

/**
 * Resolves a send-out's reason from either the generic clinical 'reason' field
 * or the structured front-office 'externalInstitutionReason' fields.
 */
export function formatSendOutExternalReason(sendOut: SendOut): string {
  if (sendOut.externalInstitutionReason) {
    switch (sendOut.externalInstitutionReason) {
      case ExternalInstitutionReason.CONTINUATION_OF_CARE:
        return "Continuation of Care";
      case ExternalInstitutionReason.LEGAL_REQUEST:
        return "Legal Request";
      case ExternalInstitutionReason.OUTSIDE_REQUEST_ADDITIONAL_TESTING:
        return "Outside Request for Additional Testing";
      case ExternalInstitutionReason.OTHER:
        return sendOut.externalInstitutionReasonOther
          ? `Other: ${sendOut.externalInstitutionReasonOther}`
          : "Other";
      default:
        return sendOut.externalInstitutionReason;
    }
  }
  return sendOut.reason || "—";
}

/**
 * Strips HTML tags from a send-out reason for plain-text display.
 */
export function stripSendOutHtml(html: string): string {
  return stripHtml(html);
}
